import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { BaseService } from '../caronte-base/base.service';
import { RouteUtils } from 'src/app/utils/route.utils';

@Injectable({
  providedIn: 'root'
})
export class PercentService {

  private totalPercentSubject = new BehaviorSubject<number>(0);


  totalPercent$ = this.totalPercentSubject.asObservable();

  constructor(private baseService: BaseService) {
  }

  getSellersPercentages(): Observable<any> {
    return this.baseService.get(RouteUtils.ENTRYPOINTS.GET_SELLER_PERCENTAGES).pipe(map(data => data.data));
  }

  putSellersPercentages(body: any): Observable<any> {
    return this.baseService.put(RouteUtils.ENTRYPOINTS.GET_SELLER_PERCENTAGES, '', body);
  }

  updateTotalPercent(percent: number) {
    this.totalPercentSubject.next(percent);
  }
}
